import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/blogger-b': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M446.6 222.7c2 8.9 2.4 134.1-2.5 151.7-7.1 25.3-17.9 44.4-35.2 62.1-23.9 24.4-49.4 37.5-81.9 41.9-18.7 2.5-201.2 1.9-216-0.8-44.5-8-88.8-44.7-104.4-94.3-6.3-20.1-7-35-6.4-136.5 0.5-81 1-95.1 3.1-103.9 11.4-46.8 42.6-83.4 86.1-100.6 23.6-9.4 39-10.8 108.4-10 44.2 0.5 57.4 1.1 63.3 2.9 24.6 7.5 46.2 20.8 65.5 40.5 27.1 27.6 40.8 58.3 40.9 91.3 0.1 17.2 2.8 23.6 12.9 29.5 6.4 3.7 8.6 4.1 28.7 5 12 0.5 23.2 1.7 25 2.7 5.7 3.1 10.7 10.5 12.5 18.5zM124.5 159.1c-12.2 12.3-6 36.1 10.6 40.8 3.1 0.8 24.3 1.4 50.8 1.2 43-0.2 45.7-0.4 50.3-3.3 8.5-5.4 12.3-12.1 12.3-21.6 0-10.6-4.1-17.2-13.4-21.9-6.4-3.3-7.9-3.4-51.8-3.4-48.8 0-51 0.3-58.8 8.2zM316.3 358.9c14.4-8.2 17-28.1 4.9-39.4-8.5-7.9-8-7.9-97.6-7.8-87.1 0.1-90.2 0.3-97.3 6.7-5.6 5.1-9.3 15.1-8.2 22.4 1.1 7.7 7.8 16.3 14.9 19.4 3.6 1.6 22.8 2.8 90.9 2l77.5-0.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/blogger-b.js
// module id = 730
// module chunks = 0